module.exports = __webpack_public_path__ + "fonts/iconfont.bf14416d.ttf";